import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router, RouterModule, RouterOutlet } from '@angular/router';

import { animate, style, transition, trigger } from '@angular/animations';

import { filter } from 'rxjs';
import { DetectTypeComponent } from './components/detect-type/detect-type.component';

@Component({
  selector: 'app-auth',
  standalone: true,
  imports: [RouterOutlet, CommonModule, RouterModule, DetectTypeComponent],
  templateUrl: './auth.component.html',
  styleUrl: './auth.component.scss',
  animations: [
    trigger('zoomIn', [
      transition('* => *', [
        style({ transform: 'scale(0.7)', opacity: 0 }),
        animate('1000ms ease-in-out', style({ transform: 'scale(1)', opacity: 1 })),
      ]),
    ]),
  ],
})
export class AuthComponent implements OnInit {
  images: any = {
    freelancer: 'assets/images/auth/freelancerImage.png',
    user: 'assets/images/auth/userImage.png',
    reset: 'assets/images/auth/login.png',
    null: 'assets/images/auth/login.png',
  };
  isMobile: boolean = false;
  checkType: boolean = true;
  type: any = this.route.snapshot.paramMap.get('type') || 'user';
  currentUrl: any = '';
  constructor(
    private router: Router,
    private breakpointObserver: BreakpointObserver,
    private route: ActivatedRoute
  ) {
    this.breakpointObserver.observe(['(max-width:1024px)']).subscribe((result) => {
      this.isMobile = result.matches;
    });
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: any) => {
        this.currentUrl = event.urlAfterRedirects;
        if (this.currentUrl.includes('detect-type')) {
          this.checkType = false;
        } else {
          this.checkType = true;
          this.route.firstChild?.paramMap.subscribe((params) => {
            this.type = params.get('type');
          });
        }
      });
  }
  ngOnInit(): void {}

  navigateToHome(): void {
    window.location.href = '/';
  }
}
